import { create } from 'zustand';

export interface MetadataItem {
  key: string;
  value?: string;
}

interface AddMetadataState {
  metadata: MetadataItem[];
}

const initialState: AddMetadataState = {
  metadata: [],
};

interface AddMetadataAction {
  updateMetadata: (metadata: MetadataItem[]) => void;
  reset: () => void;
}

export const useAddMetadataStore = create<AddMetadataState & AddMetadataAction>()((set) => ({
  ...initialState,
  updateMetadata: (metadata) => set({ metadata }),
  reset: () => set(initialState),
}));
